module.exports = __webpack_public_path__ + "static/media/unit-conversion.b07e45c4.svg";